'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _editorType = require('../../editor-type');

var _editorType2 = _interopRequireDefault(_editorType);

require('../styles/EditorSelector.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditorSelector = exports.EditorSelector = function (_BcReactComponent) {
  _inherits(EditorSelector, _BcReactComponent);

  function EditorSelector(props) {
    _classCallCheck(this, EditorSelector);

    var _this = _possibleConstructorReturn(this, (EditorSelector.__proto__ || Object.getPrototypeOf(EditorSelector)).call(this, props));

    _this.state = {};
    _this.bindAll('handleOldEditorSelected', 'handleNewEditorSelected');
    return _this;
  }

  _createClass(EditorSelector, [{
    key: 'setListType',
    value: function setListType(type) {
      this.props.handleListPropertyChange({ type: type });
    }
  }, {
    key: 'handleOldEditorSelected',
    value: function handleOldEditorSelected() {
      this.props.handleEditorSelected(false);
    }
  }, {
    key: 'handleNewEditorSelected',
    value: function handleNewEditorSelected() {
      this.props.handleEditorSelected(true);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-editor-selector' },
        _react2.default.createElement(_editorType2.default, {
          title: this.props.intl.formatMessage({ id: 'user_list_editor_new' }),
          subtitle: this.props.intl.formatMessage({ id: 'user_list_editor_new_subtitle' }),
          testId: 'new-editor',
          handleClick: this.handleNewEditorSelected }),
        _react2.default.createElement(_editorType2.default, {
          title: this.props.intl.formatMessage({ id: 'user_list_editor_legacy' }),
          testId: 'legacy-editor',
          handleClick: this.handleOldEditorSelected })
      );
    }
  }]);

  return EditorSelector;
}(_baseBcReactComponent2.default);

EditorSelector.propTypes = {
  handleNewEditorSelected: _react2.default.PropTypes.func,
  handleOldEditorSelected: _react2.default.PropTypes.func,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(EditorSelector);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-selector/components/EditorSelector.component.js
// module id = 1293
// module chunks = 0